// Who a stuck requirement is waiting on, and for how long. Staff-only: the
// customer never sees it. Mirrors QuoteRequirement.WAITING_ON on the server.

export const WAITING_ON = ["Customer", "Vendor rates", "Sample", "Internal"];

const daysSince = (d) => Math.max(0, Math.floor((Date.now() - new Date(d).getTime()) / 86400000));

// Grey while fresh, amber from 3 days, red from 7 - Exotica sat 13 unseen.
export const WaitingBadge = ({ waitingOn, waitingSince, daysOnly = false }) => {
  if (!waitingOn) return daysOnly ? null : <span className="text-muted">—</span>;
  const days = waitingSince ? daysSince(waitingSince) : null;
  const tone = days === null || days < 3 ? "bg-light text-dark" : days < 7 ? "bg-warning text-dark" : "bg-danger";
  const age = days === null ? "" : days === 0 ? "today" : `${days}d`;
  return <span className={`badge ${tone}`}>{daysOnly ? age : `${waitingOn}${age ? ` · ${age}` : ""}`}</span>;
};
